import React from 'react';
import './ConfirmationPopup.css';

const ConfirmationPopup = ({ 
  message, 
  onConfirm, 
  onCancel, 
  confirmButtonText = "Yes", 
  cancelButtonText = "Cancel" 
}) => {
  // Prevent modal from closing when clicking inside it
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup" onClick={handleModalClick}>
        <div className="confirmation-popup-message">
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        <div className="confirmation-popup-buttons">
          <button onClick={onConfirm} className="confirm-button">
            {confirmButtonText}
          </button>
          <button onClick={onCancel} className="cancel-button">
            {cancelButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
